// extracted by mini-css-extract-plugin
export var footer = "_mu-5";
export var fulfillmentInput = "_mu-0";
export var shipDateInput = "_mu-1";
export var shipmentModal = "_mu-2";
export var shipmentModalContent = "_mu-3";
export var tableContainer = "_mu-4";